import React, { Fragment, useState } from "react";
import API from "../../Network/API";
import CardLogo from "../../assets/images/card.svg";

export default function CardDetails({ course }) {

  const [payment_method, setPaymentMethod] = useState('1');
  const [term, setTerm] = useState(false);
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = event => {
    event.preventDefault();
    if (!term) return;
    setSubmitting(true);
    var ref_code = localStorage.getItem("referral_code") ?? null;
    var dataValue = {
      'payment_method': payment_method,
      'term': term ? 1 : 0,
      'course_id': course.id,
      'course_price': course.course_price,
      'referral_code': ref_code,
    }
    API.post('checkout', dataValue, {
      onUploadProgress: progressEvent => {
        console.log("Progress: " + progressEvent.loaded / progressEvent.total);
      }
    }).then(response => {
      if (response.data.success === true) {
        if (response.data.data.response_code === "0000") {
          localStorage.setItem("referral_code", null);
          window.location.href = response.data.data.payment_url;
        } else {
          setSubmitting(false);
        }
      } else {
        setSubmitting(false);
      }
    })
      .catch((error) => {
        console.log(error);
        setSubmitting(false);
      });
  }
  return (
    <Fragment>
      <div className="row">
        <form onSubmit={handleSubmit}>
          <div className="col-md-12 mb-3">
            <div className="courseContentAccordion checkoutPayment">
              <div className="accordion bg-light-white " id="accordionExample">
                <div className={`accordion-item bg-light-white paymentOption ${payment_method === '1' ? 'paymentOption--active' : ''}`}>
                  <div className="accordion-header" id="headingOne">
                    <button className="accordion-button" type="button" onClick={() => setPaymentMethod('1')}>
                      <div className="radio-item">
                        <input onChange={(e) => setPaymentMethod(e.target.value)} required={true} type="radio" id="ritemb" name="payment_method" value="1" checked={payment_method === '1'} />
                        <label htmlFor="ritemb">Cards / Internet or Mobile Banking / Web Pay / ATM</label>
                      </div>
                      <span className="lecturesHour payment_cards"><span className="me-1">
                        <img className="visa-card" src="https://d27uu9vmlo4gwh.cloudfront.net/images/v4/images/icon/master.png" alt="Mastercard" />
                        <img className="visa-card" src="https://d27uu9vmlo4gwh.cloudfront.net/images/v4/images/icon/visa.png" alt="Visa" />
                        <img className="visa-card" src="https://d27uu9vmlo4gwh.cloudfront.net/images/v4/images/icon/KBANK.png" alt="KBank" />
                        <img className="visa-card" src="https://d27uu9vmlo4gwh.cloudfront.net/images/v4/images/icon/SCB.png" alt="SCB" />
                        <img className="visa-card" src="https://d27uu9vmlo4gwh.cloudfront.net/images/v4/images/icon/BBL.png" alt="BBL" />
                        <img className="visa-card" src="https://d27uu9vmlo4gwh.cloudfront.net/images/v4/images/icon/KTB.png" alt="KTB" />
                        <img className="visa-card" src="https://d27uu9vmlo4gwh.cloudfront.net/images/v4/images/icon/BAY.png" alt="BAY" />
                        <img className="visa-card" src="https://upload.wikimedia.org/wikipedia/commons/3/39/2C2P_Logo.png" alt="2C2P" /></span>
                      </span></button>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="col-12">
            <div className="form-check termsCheck">
              <input onChange={(e) => setTerm(e.target.checked)} checked={term} required={true} className="form-check-input" type="checkbox" id="gridCheck2" name="terms" />
              <label className="form-check-label" htmlFor="gridCheck2">
                By completing my purchase I agree with these <a href={`${process.env.PUBLIC_URL}/terms_condition`} target="_blank" rel="noopener noreferrer" className="orangeRed">Terms of Service.</a>
              </label>
            </div>
          </div>
          <div className="col-12 mb-3">
            <p className="taxNote">N.B. Smart Brain is required by law to collect applicable transaction taxes for purchases made
              in certain tax jurisdictions.</p>
          </div>
          <div className="col-12 text-center mb-3">
            <button type="submit" disabled={!term || submitting} className="btn btn-lg checkoutPayBtn">
              {submitting
                ? (<><span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>Processing…</>)
                : (<><i className="fas fa-lock me-2"></i>Complete Payment</>)}
            </button>
            <p className="securePayNote"><i className="fas fa-shield-alt me-1"></i>Secure payment powered by 2C2P</p>
          </div>
        </form>
      </div>
    </Fragment>
  );
}
